import { track } from '@helsenorge/framework-utils/amplitude';
import { BruktForsideflis } from '@helsenorge/framework-utils/amplitude/ampli';
/**
 * Spor klikk på flis i tjenestepanelet
 * @param flis Flis som skal spores
 */
export const trackFlis = (flis) => {
    track(new BruktForsideflis({
        handling: 'navigere',
        objekt: 'forsideflis',
        flisNavn: flis.title ?? 'Ukjent flis',
        flisDestinasjon: flis.link ?? 'Ukjent destinasjon',
    }));
};
